<template>
  <kab-content>
    <template #section-title>
      Studios
    </template>
    <template #section-body>
      <template v-for="(studio, index) in studios">
        <studio-list 
          :id="studio.nid"
          :key="index"
          :title="studio.title"
          :master="studio.field_master"
          :image="studio.field_image"
        />
      </template>
    </template>
  </kab-content>
</template>
<script>
import { mapState } from 'vuex'
import KabContent from '../components/KabContent'
import StudioList from "@/components/Studios/StudioList"

export default {
  name: "Studios",
  components: {
    StudioList,
    KabContent
  },
  computed: {
    ...mapState(['studios'])
  },
  async created () {
    await this.$nextTick()
    this.getStudios()
  },
  methods: {
    async getStudios() {
      const loader = this.$loading.show({
        container: null,
        canCancel: true
      })
      try {
        await this.$store.dispatch('getStudios')
        loader.hide()
      } catch (error) {
        loader.hide()
        throw Error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>